import { Injectable } from '@angular/core';
import { UserRoleEnum } from '../../enums/user/user-role.enum';
import { FavieAuthService } from './favie-auth.service';

@Injectable({ providedIn: 'root' })
export class UserRoleCheckerService {
  constructor(
    private readonly favieAuthService: FavieAuthService,
  ) { }

  public isSystemAdmin(): boolean {
    const roles = this.favieAuthService.getUserRoles();
    return !!roles?.includes?.(UserRoleEnum.SUPER_ADMIN);
  }

  public isAdmin(): boolean {
    const roles = this.favieAuthService.getUserRoles();
    return !!roles?.includes?.(UserRoleEnum.ADMIN);
  }

  public isReadOnly(): boolean {
    const roles = this.favieAuthService.getUserRoles();
    return !!roles?.includes?.(UserRoleEnum.READ_ONLY);
  }
}
